import PublicLayout from './PublicLayout';

const Layout = () => (
  <PublicLayout
    surface="editorial"
    footerVariant="full"
    showFooterCta
  />
);

export default Layout;
